import React from 'react';
import { Box, Divider, SimpleGrid, Heading } from '@hover/blueprint';
import { ABOUT_US_TEAM_VALUES } from '../../../constants';

interface Props {
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

const TeamValuesTablet: React.FC<Props> = ({
  selectedValue,
  setSelectedValue,
}) => (
  <Box
    mt={800}
    flexDir="column"
    d={{ base: 'none', tablet: 'flex', desktop: 'none' }}
    px="56px"
    mb="88px"
  >
    <Divider color="green.200" opacity={1} />
    <Box flexDir="column">
      {ABOUT_US_TEAM_VALUES.map(teamValue => (
        <Box flexDir="column">
          <SimpleGrid columns={2} key={teamValue.id} py="56px" spacing="108px">
            <Box flexDir="column" maxW={700}>
              <Heading
                onClick={() => setSelectedValue(teamValue.value)}
                marginBottom={selectedValue === teamValue.value ? 600 : 0}
                size={900}
                color={
                  selectedValue === teamValue.value ? 'green.500' : 'green.100'
                }
                cursor="pointer"
              >
                {teamValue.title}
              </Heading>
              <Heading
                marginBottom={0}
                size={200}
                isDisplay
                d={selectedValue === teamValue.value ? 'block' : 'none'}
              >
                {teamValue.body}
              </Heading>
            </Box>
            <Box
              d={selectedValue === teamValue.value ? 'flex' : 'none'}
              alignItems="center"
            >
              {teamValue.image}
            </Box>
          </SimpleGrid>
          <Divider color="green.200" opacity={1} />
        </Box>
      ))}
    </Box>
  </Box>
);

export default TeamValuesTablet;
